import { ActionGroupTypes, ActionStatusTypes } from "../../../enum/ActionStatusTypes";
import * as logger from "../../../logger";
import * as systemUtils from "../../../utils/systemUtils";
import { ACTION_PREFIX_PARAMETER } from "./abstract/rootAbstract";

const _action = `${ACTION_PREFIX_PARAMETER}_edit`;
const _header = `Edit model`;

export const editModel = (root) => {
  const _payload = editModelLogic();

  logger.logAction(_action, _payload, ACTION_PREFIX_PARAMETER);

  return { root, info: _payload };
};

const editModelLogic = () => {
  return generatePayload();
};

//--------------------------------------------------------------------------------

const generatePayload = () => {
  const _payload = {
    group: ActionGroupTypes.UPDATE,
    status: ActionStatusTypes.SUCCESS,
    action: _action,
    time: systemUtils.getTimestamp(),
    header: _header,
    description: `Manual edit.`,
  };

  return _payload;
};
